import { useState, useEffect, createContext } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";

const MiscContext = createContext();

export function MiscContextProvider(props) {

  const location = useLocation();

  const [showInviteSection, setShowInviteSection] = useState(false);
  const [isInviteSuccessful, setIsInviteSuccessful] = useState(false);
  const [showInviteSuccessSection, setShowInviteSuccessSection] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");


  const context = {
    showInviteSection: showInviteSection,
    setShowInviteSection: setShowInviteSection,
    isInviteSuccessful: isInviteSuccessful,
    setIsInviteSuccessful: setIsInviteSuccessful,
    showInviteSuccessSection: showInviteSuccessSection,
    setShowInviteSuccessSection: setShowInviteSuccessSection,
    selectedSection: selectedSection,
    setSelectedSection: setSelectedSection
  };

  return <MiscContext.Provider value={context}>
    {props.children}
  </MiscContext.Provider>
}

export default MiscContext;

